import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MdOutlineArrowForward } from 'react-icons/md';
import { BsTelephone, BsBriefcase } from 'react-icons/bs';
import { FaAtom } from 'react-icons/fa';
import { FiUserCheck } from 'react-icons/fi';
import { IoMdHourglass } from 'react-icons/io';
import { TbUsersGroup } from 'react-icons/tb';

export default function ServicesComp() {
    
    const [isListView, setIsListView] = useState(false);

    const ServicesComp = [
        {
            icon: BsTelephone,
            title: '24/7 Support',
            data: 'Many desktop publishing now use and a search for job',
        },
        {
            icon: FaAtom,
            title: 'Tech & Startup Jobs',
            data: 'Many desktop publishing now use and a search for job',
        },
        {
            icon: FiUserCheck,
            title: 'Quick & Easy',
            data: 'Many desktop publishing now use and a search for job',
        },
        {
            icon: IoMdHourglass,
            title: 'Save Time',
            data: 'Many desktop publishing now use and a search for job',
        },
        {
            icon: FiUserCheck,
            title: 'Apply with confidence',
            data: 'Many desktop publishing now use and a search for job',
        },
        {
            icon: FiUserCheck,
            title: 'Reduce Hiring Bias',
            data: 'Many desktop publishing now use and a search for job',
        },
        {
            icon: BsBriefcase,
            title: 'Proactive Employers',
            data: 'Many desktop publishing now use and a search for job',
        },
        {
            icon: TbUsersGroup,
            title: 'No Missed Opportunities',
            data: 'Many desktop publishing now use and a search for job',
        },
    ];

    return (
        <div className="container">
            
            <button
                onClick={() => setIsListView(!isListView)}
                className="mb-4 px-4 py-2 bg-emerald-600 text-white rounded-md"
            >
                {isListView ? 'Switch to Cards View' : 'Switch to List View'}
            </button>
            <div className={isListView ? 'space-y-4' : 'grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-[30px]'}>
                {ServicesComp.map((item, index) => {
                    const Icon = item.icon;

                    return isListView ? (
                        <div key={index} className="flex items-center p-4 bg-white shadow rounded-md dark:bg-slate-900 dark:shadow-gray-700">
                            <Icon className="text-[30px] text-emerald-600 mr-4" />
                            <div>
                                <Link to="#" className="text-lg font-semibold hover:text-emerald-600">{item.title}</Link>
                                <p className="text-slate-400 mt-2 mb-2">{item.data}</p>
                                <Link to="#" className="hover:text-emerald-600 font-medium inline-flex items-center">
                                    Read More <MdOutlineArrowForward className="ms-1" />
                                </Link>
                            </div>
                        </div>
                    ) : (
                        <div key={index} className="group p-6 shadow dark:shadow-gray-700 rounded-md bg-white hover:bg-emerald-600/5 dark:bg-slate-900 dark:hover:bg-emerald-600/10 text-center transition-all duration-500">
                            <div className="w-16 h-16 flex items-center justify-center mx-auto bg-emerald-600/5 group-hover:bg-emerald-600 dark:bg-emerald-600/10 dark:group-hover:bg-emerald-600 shadow dark:shadow-gray-700 rounded-lg transition-all duration-500">
                                <Icon className="text-[30px] text-emerald-600 group-hover:text-white" />
                            </div>

                            <div className="mt-4">
                                <Link to="#" className="text-lg font-semibold hover:text-emerald-600 transition-all duration-500">{item.title}</Link>

                                <p className="text-slate-400 mt-3 mb-2">{item.data}</p>

                                <Link to="#" className="hover:text-emerald-600 font-medium transition-all duration-500 items-center inline-flex">Read More <MdOutlineArrowForward className="ms-1" /></Link>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
